import React from "react";
import { partners } from "../mock/mock";

const PartnerMarquee = () => {
  const list = [...partners, ...partners];
  return (
    <div className="overflow-hidden py-6">
      <div className="marquee-track whitespace-nowrap">
        {list.map((p, i) => (
          <span
            key={i}
            className="text-xl sm:text-2xl font-bold text-slate-400 hover:text-blue-700 transition-colors shrink-0"
          >
            {p}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PartnerMarquee;
